import React from 'react';
import NavBar from './Navbar/NavBar';
import ContactSvg from '../images/contact.svg';
import SectionHeading from './SectionHeading';

const Contact = () => {
    return (
        <div id="contact" className="bg-white pt-24 pb-16 md:pb-20">
            <NavBar />
            <section data-aos="zoom-in-down" className="container-app">
                <SectionHeading eyebrow="Kontak" title="Hubungi Kami" />

                <div className="flex flex-col items-center justify-center">
                    <p className="max-w-3xl mx-auto text-center text-slate-600 leading-relaxed">
                        Kami siap membantu Anda dengan solusi keamanan dan kebersihan terbaik.
                        Tim profesional kami selalu siap memberikan layanan yang cepat, responsif, dan berkualitas tinggi.
                        Jangan ragu untuk menghubungi kami melalui informasi di bawah ini atau mengisi formulir kontak.
                        Kami akan segera merespons kebutuhan Anda.
                    </p>

                    <div className="flex items-center justify-center mt-10 w-full">
                        <img
                            alt="Ilustrasi kontak"
                            className="rounded-2xl w-full max-w-md lg:max-w-2xl"
                            src={ContactSvg}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
